import {
  type SchedulerJobsResponse,
  SchedulerJobsResponseSchema,
  type SchedulerRunsListQuery,
  type SchedulerRunsListResponse,
  SchedulerRunsListResponseSchema,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const listSchedulerJobs = async (): Promise<SchedulerJobsResponse> => {
  const { data } = await apiClient.get<unknown>('/scheduler/jobs');
  return SchedulerJobsResponseSchema.parse(data);
};

export const listSchedulerRuns = async (
  query: SchedulerRunsListQuery,
): Promise<SchedulerRunsListResponse> => {
  const { data } = await apiClient.get<unknown>('/scheduler/runs', { params: query });
  return SchedulerRunsListResponseSchema.parse(data);
};
